<template>
  <fa-icon icon="broom" />
</template>
